<a (click)="navigateToUserProfile()" class="d-flex align-items-center nav-link cursor-pointer"
   *ngIf="user$| async as user">
  <img class="rounded-circle profile-picture"
       [src]="(userService.getProfilePicture(user.id) |async) ??'assets/img/profile/default-profile-icon.png'"
       alt="Avatar"/>
  <div class="user-name ms-2 hide-on-collapse"
  >{{user.firstName}} {{user.lastName}}</div>
</a>
